import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
export default function renderElement(_ref) {
  var match = _ref.match,
    Component = _ref.Component,
    isComponentResolved = _ref.isComponentResolved,
    hasComponent = _ref.hasComponent,
    querySubscription = _ref.querySubscription,
    resolving = _ref.resolving;
  var route = match.route,
    router = match.router;
  var readyState = querySubscription.readyState,
    environment = querySubscription.environment,
    variables = querySubscription.variables;
  var error = readyState.error,
    props = readyState.props;
  if (!route.render) {
    if (!isComponentResolved || !error && !props) {
      return undefined;
    }
    if (!props || !hasComponent) {
      if (process.env.NODE_ENV !== 'production') console.error("Route with query `".concat(querySubscription.getQueryName(), "` has no render method or component."));
      return null;
    } // @ts-ignore

    return /*#__PURE__*/React.createElement(Component, _extends({
      match: match,
      router: router
    }, props));
  }
  return route.render(Object.assign({}, readyState, {
    match: match,
    Component: isComponentResolved ? Component : null,
    props: props && Object.assign({
      match: match,
      router: router
    }, props),
    environment: environment,
    variables: variables,
    resolving: resolving
  }));
}